import './polymer-loading.scss';

new Vue({
	el: '.mui-content',
	data() {
		return {
			isMobile: false
		}
	},
	components: {},
	created() {
		if (this.isMobileDevice() || this.isIpad()) {
			//手机或平板
			this.isMobile = true
		} else {
			//PC端
			this.isMobile = false
		}
		if (this.isMobile) {
			if (common.getUrlParam('code')) {
				this.submitLogin()
				return
			}
			common.openWindow({
				url: '../../polymer/polymer-list/polymer-list.html',
				id: 'polymer'
			})
			// common.openWindow({
			// 	url: '../../login/app-login/app-login.html',
			// 	id: 'login'
			// })
			// location.href = location.origin + '/wechat' + '/page/polymer/polymer-list/polymer-list.html' + location.search
		} else {
			if (common.getUrlParam('code')) {
				location.href = location.origin + '/#/loading' + location.search
				return
			}
			location.href = location.origin + '/#/'
		}
	},
	mounted() { },
	methods: {
		// 使用userAgent判断
		isMobileDevice() {
			return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		},
		// 使用媒体查询判断
		isMobileViewport() {
			return window.matchMedia("(max-width: 767px)").matches;
		},
		// 判断新款pad
		isIpad() {
			return (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
		},
		// 移动端跳转拦截登录
		submitLogin() {
			this.$ajax({
				url: 'dangxiao/login',
				type: 'GET',
				data: {
					code: common.getUrlParam('code')
				}
			}).then((res) => {
				if (res.data.code == '2000') {
					localStorage.setItem('isLogin', true)
					location.href = location.origin + '/wechat' + '/page/polymer/polymer-list/polymer-list.html' + location.search
				} else if (res.data.code == '4001' || res.data.code == '5000' || res.data.code == '401') {
					common.openWindow({
						id: "no-permission",
						url: "../../login/no-permission/no-permission.html"
					});
				}
			}).catch(err => {
				console.log(err.message)
				mui.toast(err)
			})
		}
	}
});
